export default __webpack_public_path__ + "static/media/luxfeliz.387ff506.png";